import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { MaterialModule } from '../../shared/material/material.module';
import { DeviceDetectorService } from 'ngx-device-detector';

interface MenuNode {
  name: string;
  route?: string;
  children?: MenuNode[];
}

@Component({
    selector: 'app-admin',
    standalone: true,
    imports: [RouterOutlet, MaterialModule],
    templateUrl: './admin.component.html'
})
export class AdminComponent {

  deviceService = inject(DeviceDetectorService);
  dataSource = EXAMPLE_DATA;

  childrenAccessor = (node: MenuNode) => node.children ?? [];

  hasChild = (_: number, node: MenuNode) => !!node.children && node.children.length > 0;
}

const EXAMPLE_DATA: MenuNode[] = [
  {
    name: 'Suporte',
    children: [
      { name: 'Atendimento', route: '/admin' },
      { name: 'FAQ', route: 'admin-faq' },
      { name: 'Profissoes', route: 'admin-profession' },
      { name: 'Notificacoes', route: 'admin-notification' },
      { name: 'Consulta de Acessos', route: 'access-overview' }

    ]
  },
  {
    name: 'Administração',
    children: [
      { name: 'Documentos Compartilhado', route: 'admin-document-share' },
      { name: 'Produtos', route: 'admin-products' },
      { name: 'Pacotes de produtos e Descontos', route: 'admin-products-package' },
      { name: 'Planos', route: 'admin-plan' },
      { name: 'Pagamentos', route: 'admin-payment' },
    ],
  },
];
